// Toaster.js
import React from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

const Toaster = ({ show, message, variant, onClose }) => {
  return (
    <ToastContainer position="bottom-start" className="p-3">
      <Toast onClose={onClose} show={show} delay={5000} autohide>
        <Toast.Header className={`${variant === 'success' ? 'bg-success' : 'bg-danger'} text-white`}>
          <strong className="me-auto">{variant === 'success' ? 'Success' : 'Error'}</strong>
        </Toast.Header>
        <Toast.Body className={`${variant === 'success' ? 'bg-success' : 'bg-danger'} text-white`}
            dangerouslySetInnerHTML={{ __html: message }}
            >
          {/* {message} */}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default Toaster;
